import React, { FC, ReactElement, useEffect, useState } from 'react';
import Icon from '../../../Icon';
import { Sponsor, SponsorContacts } from '../SponsorPage';
import './sponsors-contacts.sass';
import { useSelector } from 'react-redux';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
import { internalizationState } from '../../../../stores/reducers/sections';

interface Props {
  sponsorData: Sponsor
}

const SponsorsContacts: FC<Props> = ({ sponsorData }): ReactElement => {
  const [ sponsor, setSponsor ] = useState<any>();
  const [ contacts, setContacts ] = useState<Array<SponsorContacts>>([]);

  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    website_ru: 'Сайт',
    website_en: 'Website',
    phone_ru: 'Телефон',
    phone_en: 'Phone',
    personalContacts_ru: 'Персональные контакты',
    personalContacts_en: 'Personal contacts',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);

  useEffect(() => {
    setSponsor(sponsorData);
    setContacts(sponsorData.contacts);
  }, [sponsorData]);

  const trimString = (str: string): string => {
    let tempString = str;
    if (tempString.includes('(доб.')) {
      tempString = tempString.split('(')[0];
    }
    return tempString.replace(/\s/g, '');
  };
  
  return (
    <>
      {
        sponsor &&
          <div className="sponsors-contacts flex flex-column">
            {
              sponsor.website && (
                <div className="sponsors-contacts__item flex items-center mb-20">
                  <div className="flex mr-16">
                    <Icon name="earth-big" />
                  </div>
                  <div className="flex flex-column">
                    <span>{ localizedName('website_ru') }</span>
                    <a className="sponsors-contacts__value" href={`//${sponsor.website}`} target="_blank" rel="noopener noreferrer">{sponsor.website}</a>
                  </div>
                </div>
              )
            }

            {
              sponsor.email && (
                <div className="sponsors-contacts__item flex items-center mb-20">
                  <div className="flex mr-16">
                    <Icon name="mail-big" />
                  </div>
                  <div className="flex flex-column">
                    <span>E-mail</span>
                    <a className="sponsors-contacts__value" href={`mailto:${sponsor.email}`}>{sponsor.email}</a>
                  </div>
                </div>
              )
            }

            {
              sponsor.phone && (
                <div className="sponsors-contacts__item flex items-center mb-20">
                  <div className="flex mr-16">
                    <Icon name="phone-big" />
                  </div>
                  <div className="flex flex-column">
                    <span>{ localizedName('phone_ru') }</span>
                    <a className="sponsors-contacts__value" href={`tel:${trimString(sponsor.phone)}`}>{sponsor.phone}</a>
                  </div>
                </div>
              )
            }
        </div>
      }

      {
        contacts && contacts.length ?
          <div className="personal-contacts">
            <h3 className="personal-contacts__title">{ localizedName('personalContacts_ru') }</h3>
            {
              contacts.map((contact: SponsorContacts, index: number): ReactElement => {
                return (
                  <div className="flex flex-column pt-8 mb-16" key={index}>
                    <h4 className="personal-contacts__name">
                      { localeFieldResolver(contact, 'name', activeLangState) }
                    </h4>
                    { contact.post &&
                      <p className="mb-16"><i>{ localeFieldResolver(contact, 'post', activeLangState) }</i></p>
                    }
                    {
                      contact.email &&
                      <div className="personal-contacts__item flex items-center pl-8 mb-8">
                        <div className="flex mr-8">
                          <Icon name="mail-small" />
                        </div>
                        <a href={`mailto:${contact.email}`}>{contact.email}</a>
                      </div>
                    }
                    {
                      contact.phone && (
                        <div className="personal-contacts__item flex items-start pl-8">
                          <div className="flex mr-8">
                            <Icon name="phone-small" />
                          </div>
                          <div className="flex flex-column">
                          <a href={`tel:${trimString(contact.phone)}`}>{contact.phone}</a>
                          </div>                    
                        </div>
                      )
                    }
                  </div>
                )
              })
            }
          </div>
        :
          ''
      }
      
    </>
  )    
}

export default SponsorsContacts
